import {
  Select,
  SelectItem,
  SelectPopup,
  SelectTrigger,
} from '@/components/ui/select';
import {FC} from 'react';
import {EventRoute} from '../eventRoutes';
import {RouteHeader} from '../routeHeader/routeHeader';

interface RouteDropdownProps {
  routes: EventRoute[];
  activeRoute: EventRoute | null;
  onSelect: (routeId: string) => void;
  /** Placeholder shown when no route is selected. Defaults to "Select a route". */
  placeholder?: string;
  size?: 'compact' | 'normal';
  /** Id of the element that visually labels this dropdown, used for `aria-labelledby`. */
  'aria-labelledby'?: string;
}

/** Dropdown selector for when there are many routes. */
export const RouteDropdown: FC<RouteDropdownProps> = ({
  routes,
  activeRoute,
  onSelect,
  placeholder = 'Select a route',
  'aria-labelledby': ariaLabelledBy,
}) => {
  return (
    <Select
      value={activeRoute?.id ?? null}
      onValueChange={(value) => {
        if (typeof value === 'string') onSelect(value);
      }}
    >
      <SelectTrigger
        className="h-auto p-4 items-center"
        aria-labelledby={ariaLabelledBy}
      >
        {activeRoute ? (
          <div className="min-w-0 flex-1">
            <RouteHeader route={activeRoute} />
          </div>
        ) : (
          <span className="text-sm text-neutral-500">{placeholder}</span>
        )}
      </SelectTrigger>
      <SelectPopup>
        {routes.map((route) => (
          <SelectItem
            key={route.id}
            value={route.id}
            className="py-3 items-start"
          >
            <RouteHeader route={route} />
          </SelectItem>
        ))}
      </SelectPopup>
    </Select>
  );
};
